// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"3c10764d","812":"42774441"}[chunkId] + ".chunk.js";
};